import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
    createStyles({
        '@font-face': {
            fontFamily: 'MyWebFont',
            src: "url('../assets/fonts/NotoSansArmenian-Regular.ttf')"
        },
        '@global': {
            '*': {
                boxSizing: 'border-box',
                margin: 0,
                padding: 0,
                fontFamily: "MyWebFont,sans-serif!important",
            },
            a: {
                color: '#000000',
                textDecoration: "underline",
                '&:hover': {
                    color: '#5BC0F7',
                },
            },
            button: {
                outline: 'none',
                '&:focus': {
                    outline: 'none',
                },
            },
            ul: {
                listStyle: "none"
            },
            input: {
                '&:focus': {
                    outline: 'none',
                },

                '&::-webkit-outer-spin-button': {
                    '-webkit-appearance': 'none',
                    margin: 0,
                },
                '&::-webkit-inner-spin-button': {
                    '-webkit-appearance': 'none',
                    margin: 0,
                },
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 1000px white inset',
                },
            },
        },
    }),
);

const NormalizeStyles = () => {
    useStyles();

    return null;
};

export default NormalizeStyles;
